import React from 'react';
import { createUseStyles } from 'react-jss';
import { format, startOfMonth } from 'date-fns';
import cx from 'classnames';
import { Theme } from '_lib/theme';
import ChevronToggle from '../ChevronToggle';
import isDateInPast from '../_lib/helpers/isDateInPast';

const days = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    fontFamily: theme.typography.fontFamily,
    background: '#fff',
  },
  headerContainer: {
    marginBottom: 8,
    fontWeight: 700,
    textAlign: 'center',
    height: 20,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    color: '#7a8ba5',
  },
  day: {
    flex: 1,
    fontSize: 12,
  },
  dayLarge: {
    fontSize: 16,
  },
  titleWrapper: {
    display: 'flex',
  },
  title: {
    margin: '7px 0 31px 11px',
    fontSize: 16,
    color: '#282C37',
  },
  titleLarge: {
    fontSize: 36,
    marginLeft: '4%',
    marginBottom: 14,
  },
  chevronContainer: {
    marginLeft: 'auto',
    marginTop: 3,
    marginRight: 10,
  },
  chevronContainerLarge: {
    marginTop: 16,
    marginRight: '4%',
  },
}));

type Props = {
  date: Date | string;
  onClickLeft?: () => void;
  onClickRight?: () => void;
  size?: 'small' | 'large';
  allowPastSelection?: boolean;
};

const CalendarHeader = (props: Props) => {
  const {
    date,
    onClickLeft,
    onClickRight,
    size = 'small',
    allowPastSelection = false,
  } = props;
  const classes = useStyles();
  const formattedDate = format(
    new Date(date),
    size === 'large' ? 'MMM, yyyy' : 'MMMM yyyy'
  );

  const isLarge = size === 'large';

  const titleStyle = cx({
    [classes.title]: true,
    [classes.titleLarge]: isLarge,
  });

  const dayStyle = cx({
    [classes.day]: true,
    [classes.dayLarge]: isLarge,
  });

  const chevronContainerStyle = cx({
    [classes.chevronContainer]: true,
    [classes.chevronContainerLarge]: isLarge,
  });

  return (
    <div className={classes.container}>
      <div className={classes.titleWrapper}>
        <h3 className={titleStyle}>{formattedDate}</h3>
        <div className={chevronContainerStyle}>
          <ChevronToggle
            disableLeft={
              !allowPastSelection && isDateInPast(startOfMonth(new Date(date)))
            }
            onClickLeft={onClickLeft}
            onClickRight={onClickRight}
            size={size}
            direction="horizontal"
          />
        </div>
      </div>
      <div className={classes.headerContainer}>
        {days.map(day => (
          <div key={day} className={dayStyle}>
            {day}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CalendarHeader;
